import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { formatDate } from "@ui-seeker/utils";

export const CELL_MIN_WIDTH = 78

// Three levels in one header cell: pickup date, its lengths of rental, and the acriss codes
// of each one. `AppBasicTable` paints a single header row, so the depth lives inside the cell.
export default function datesHeader(header, lors, acrissCodes) {

	return {
		setHeaderCellProps: () => ({
			sx: {
				p: 0,
				borderBottom: 0,
				minWidth: CELL_MIN_WIDTH * lors.length * acrissCodes.length,
				backgroundColor: 'primary.main',
			},
		}),
		render: () => <Box key={`${header}-${lors.join("-")}`}>
			<Box sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				flexDirection: 'column',
				gap: 1,
				backgroundColor: 'primary.main',
				pt: 1,
			}}>
				<Typography sx={{ fontWeight: 'bold' }}>{formatDate(header, { isString: true, format: 'dd/MM' })}</Typography>
				<Box sx={{ backgroundColor: 'primary.dark', color: 'secondary.contrastText', width: '100%' }}>
					<Grid container>
						{lors.map((lor, idx) => <Grid key={`${header}-${lor}-${idx}`} item xs={12 / lors.length}>
							<Typography sx={{ fontWeight: 'bold', textAlign: 'center' }}>{lor}</Typography>
							<Grid container>
								{acrissCodes.map((acriss, acrissIdx) => <Grid
									key={`${header}-${lor}-${acriss}-${acrissIdx}`}
									item
									xs={12 / acrissCodes.length}
								>
									<Typography variant="caption" sx={{ display: 'block', textAlign: 'center' }}>
										{acriss}
									</Typography>
								</Grid>)}
							</Grid>
						</Grid>)}
					</Grid>
				</Box>
			</Box>
		</Box>
	}
}
